<script lang="ts">
    import { openModal } from 'svelte-modals';
    import { onMount } from 'svelte';
    import { _ } from 'svelte-i18n';
    import { z } from 'zod';

    import { SettingsApi } from '../../Settings/SettingsApi';
    import ModalError from '../../../shared/Modals/ModalError.svelte';
    import { planning } from '../../../../stores/store.js';
    import Opacity from '../../../shared/Opacity.svelte';
    import Checkbox from '../../../shared/Checkbox/Checkbox.svelte';
    import { api } from '../../../../stores/api';

    let checked: boolean = $planning.adHocMode === true;

    onMount(() => {
        Promise.all([
            SettingsApi.getClientSettings<boolean>(
                $api,
                'planningAdHocMode',
                z.boolean().catch(false)
            ),
        ])
            .then(([settings]) => {
                $planning.adHocMode = settings;
                checked = $planning.adHocMode;
            })
            .catch(e => {
                console.warn(e);
            });
    });

    $: {
        if ($planning.adHocMode !== checked) {
            (async () => {
                $planning.adHocMode = checked;
                await SettingsApi.setClientSettings(
                    $api,
                    'planningAdHocMode',
                    $planning.adHocMode,
                    z.boolean()
                ).catch(e => {
                    console.warn(e);
                    openModal(ModalError, {
                        message: $_('save_changes_failed'),
                    });
                });
            })();
        }
    }
</script>

<Opacity opacity={$planning.adHocModeEnabled ? 1 : 1}>
    <Checkbox
        disabled={!$planning.adHocModeEnabled && !$planning.adHocMode}
        label={$_('only') +
            " <span style='color: var(--planning-page-accent-color); padding-left: 5px; font-weight: 600;'>ad-hoc</span>"}
        bind:checked
    />
</Opacity>
